<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4>Sales Orders</h4>
              <div class="buttonWrapper">
                <a *ngIf="addPermission === true" style="margin-right: 7px;" class="btn btn-success btn-sm" mat-raised-button href="https://www.sageone.com/oauth2/auth/central?response_type=code&client_id={{CALLBACK_CLIENT_ID}}&redirect_uri={{CALLBACK_URL}}&scope=full_access" target="_blank"><i
                  class="fa fa-plus" aria-hidden="true"></i>Sync</a>
                <!-- <button *ngIf="addPermission === true" class="btn btn-success btn-sm" mat-raised-button (click)="openDialog()"><i
                  class="fa fa-plus" aria-hidden="true"></i>ADD
                  NEW
                </button>
                <button *ngIf="searchByStatus == 'New' && approvalPermission === true" class="btn btn-primary btn-sm" (click)="editDialog(selectedIndex)"><i
                  class="fa fa-thumbs-o-up" aria-hidden="true"></i>Approve
                </button>
                <button *ngIf="searchByStatus !== 'New' && addPermission === true" class="btn btn-dark btn-sm" (click)="editDialog(selectedIndex)"><i
                  class="fa fa-pencil-square-o" aria-hidden="true"></i>Reorder
                </button>
                <button *ngIf="searchByStatus == 'New' && editPermission === true" class="btn btn-warning btn-sm" (click)="editDialog(selectedIndex)"><i
                  class="fa fa-pencil-square-o" aria-hidden="true"></i>EDIT
                </button>
                <button *ngIf="searchByStatus !== 'New' && editPermission === true" class="btn btn-warning btn-sm" (click)="editDialog(selectedIndex)"><i
                  class="fa fa-street-view" aria-hidden="true"></i>View
                </button>
                <button *ngIf="searchByStatus == 'New' && deletePermission === true" class="btn btn-danger btn-sm" (click)="deleteDialog(selectedIndex)"><i
                  class="fa fa-trash" aria-hidden="true"></i>DELETE
                </button> -->
              </div>
            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th class="col1">PO No</th>
                <th class="col3">Date</th>
                <th class="col2">Status</th>
                <th class="col4">Country</th>
                <th class="col5">City</th>
                <th class="col6">Grand Total</th>
                <th class="col7">Discount</th>
                <th class="col8">Net Total</th>
              </tr>
              </thead>
              <tbody>
              <!-- (dblclick)="editDialog(selectedIndex)" -->
              <tr rowspan=""
                  *ngFor="let in of purchaseorder | paginate: { id: 'stockPageId', itemsPerPage: perPage, currentPage: currentPage, totalItems: totalCount}; let i = index "  (dblclick)="editDialog(selectedIndex)"
                  (click)="selectRow(i)" [ngClass]="{'sel': i === selectedIndex }"
                   style="height: 36px;">
                <td scope="col9">{{in.id}}</td>
                <td class="col11">{{in.purchase_order_date }}</td>
                <td class="col10">{{in.status }}</td>
                <td class="col12">{{in.countries_name}}</td>
                <td class="col13">{{in.location_name}}</td>
                <td class="col14 text-right">{{in.grand_total | number:'1.2-2'}}</td>
                <td class="col15 text-right">{{in.total_discount | number:'1.2-2'}}</td>
                <td class="col16 text-right">{{in.net_total | number:'1.2-2' }}</td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">
                <div class="input-group">
                  <select name="searchBy" [(ngModel)]="searchByStatus" data-show-content="true" class="form-control border" (ngModelChange)="doSearch()">
                    <option [ngValue]="'New'"> New Sales Order</option>
                    <option [ngValue]="'Approved'"> Approved Sales Order</option>
                    <option [ngValue]="'In-Progress'"> In-Progress Sales Order</option>
                    <option [ngValue]="'Completed'"> Completed Sales Order</option>
                  </select>
                  <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true" class="form-control ">
                    <option [ngValue]="0"> Search by Sales No
                    </option>
                    <option [ngValue]="1"> Search by Sales
                      Date
                    </option>
                  </select>
                  <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">
                  <span class="input-group-text" (click)="doSearch()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <span class="input-group-text" (click)="doRefresh()">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </div>
</div>



